var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('emails-history-provider',{attrs:{"email-type":_vm.emailType,"template-id":_vm.templateId}},[_c('email-history-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }